export default __webpack_public_path__ + "static/media/eggplant.9236eb70.svg";